import { render, staticRenderFns } from "./WarhallAdminConfigPanel.vue?vue&type=template&id=1d18682a&scoped=true"
import script from "./WarhallAdminConfigPanel.vue?vue&type=script&lang=js"
export * from "./WarhallAdminConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./WarhallAdminConfigPanel.vue?vue&type=style&index=0&id=1d18682a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18682a",
  null
  
)

export default component.exports